"use client"
import Link from "next/link";
import Image from "next/image";
import { Minus } from "lucide-react";
import { dataLinkCategory } from "../LinkHeader";

const MenuContent = () => {
  return (
    <div className="flex w-full py-5 px-10 bg-main">
      {dataLinkCategory.map((item, idx) => {
        return (
          <div key={item.title} className="w-52 p-2 bg-white m-2 rounded-md">
            <Link
              className="inline font-bold border-b-2 hover:text-pink border-patch my-2 text-text text-lg"
              href={item.src}
            >
              {item.title}
            </Link>
            {item.children.map((child, index) => (
              <Link
                className="flex items-center text-sm my-2 hover:text-pink hover:mr-1 transition-all duration-300 hover:font-bold opacity-80"
                key={child.title}
                href={child.src}
              >
                <Minus className="size-4 ml-1" /> {child.title}
              </Link>
            ))}
          </div>
        );
      })}
      <Link href="/product/maison-francis-kurkdjian-baccarat-rouge-540-for-women-and-men-extrait-de-parfum">
        <Image
          className="rounded-full"
          height={300}
          width={300}
          src="/images/baccarat-rouge.jpg"
          alt={"baccarat-rouge"}
        />
      </Link>
    </div>
  );
};

export default MenuContent;
